var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools02-promotions"},[_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(
      _vm.tool.codeKebab === 'facebook-cv' ||
      _vm.tool.codeKebab === 'tiktok-cv' ||
      _vm.tool.codeKebab === 'line-cv' ||
      _vm.tool.codeKebab === 'yda-cv' ||
      _vm.tool.codeKebab === 'smartnews-cv'
    ),expression:"\n      tool.codeKebab === 'facebook-cv' ||\n      tool.codeKebab === 'tiktok-cv' ||\n      tool.codeKebab === 'line-cv' ||\n      tool.codeKebab === 'yda-cv' ||\n      tool.codeKebab === 'smartnews-cv'\n    "}]},[_c('el-col',[_c('h2',[_vm._v("プログラム一覧")])])],1),_c('Tools02PromotionsPromotionList',{attrs:{"accountId":_vm.accountId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }